import {
  addDataToStore,
  getStore,
  removeDataFromStore,
} from 'utils/helpers/localStorageHelpers';

// Intended to match Action Referral Period in CJ program terms
const CJ_LOOK_BACK_WINDOW_DAYS = 45;

const isStale = (timestamp: number, maxDays: number): boolean => {
  const millisecondsInADay = 1000 * 3600 * 24;
  const ageInDays = (Date.now() - timestamp) / millisecondsInADay;
  return ageInDays > maxDays;
};

/**
 * Save an incoming Commission Junction attribution ID to localStorage
 */
export const updateCJEvent = (eventId: string): void => {
  const cJEvent = JSON.stringify({
    eventId,
    timestamp: Date.now(),
  });
  addDataToStore({ cJEvent });
};

/**
 * Retrieve the ID used to attribute purchases to Commission Junction (CJ)
 */
export const getCJEventId = (): string | null => {
  const store = getStore();
  const { cJEvent: rawEvent } = store;
  const event = rawEvent && JSON.parse(rawEvent)
  if (
    event?.timestamp &&
    isStale(event.timestamp, CJ_LOOK_BACK_WINDOW_DAYS)
  ) {
    removeDataFromStore('cJEvent');
    return null;
  }
  return event ? event?.eventId : null;
};
